import React from "react";
import { CloseIconThin, HelpDrawer } from "@cmsgov/ds-medicare-gov";
import { useTranslate } from "../../../helpers";

export const LearnAboutTiers: React.FunctionComponent<{
  onSetShowDrugTierHelp: (b: boolean) => void;
}> = ({ onSetShowDrugTierHelp }) => {
  const t = useTranslate();

  return (
    <div className="mct-c-help-drawer">
      <HelpDrawer
        heading={t("plan_terms.learn_about_tiers")}
        onCloseClick={(): void => onSetShowDrugTierHelp(false)}
        closeButtonText={<CloseIconThin />}
        ariaLabel={t("plan_terms.close_drug_tier_help_drawer")}
      >
        <p>{t("plan_terms.drug_tiers.help_drawer.description1")}</p>
        <p>
          {t("plan_terms.drug_tiers.help_drawer.description2")}
          &nbsp;
          <a
            className="ds-u-color--secondary"
            target="_blank"
            href="https://www.medicare.gov/medicare-prescription-drug-coverage-appeals"
            rel="noopener noreferrer"
          >
            Medicare.gov/medicare-prescription-drug-coverage-appeals
          </a>
        </p>
        <p>{t("plan_terms.drug_tiers.help_drawer.description3")}</p>
      </HelpDrawer>
    </div>
  );
};
